import { CheckIcon } from '@assets/icons';
import { Typography } from '@components/typography';
import { MenuItem, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

export const CopySshLaunchCommandMenuItem = ({ editorId }: { editorId: string }) => {
  const { palette } = useTheme();

  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 3000);
    return () => clearTimeout(timer);
  }, [copied]);

  const handleCopySshLaunchCommand = async () => {
    const sshCommand = `ssh -p 443 ${editorId}@tyrell-proxy.${process.env.GATSBY_ENV}.rendered.ai`;
    try {
      await navigator.clipboard.writeText(sshCommand);
      setCopied(true);
    } catch {
      // Clipboard API may fail in some contexts (e.g. non-HTTPS)
    }
  };

  return (
    <MenuItem onClick={handleCopySshLaunchCommand} sx={{ minWidth: '20ch' }}>
      {copied ? (
        <CheckIcon size={14} color={palette.success.main} style={{ marginRight: '4px' }} />
      ) : null}
      <Typography
        variant="caption2"
        sx={{ color: copied ? palette.success.main : palette.text.primary }}
      >
        {copied ? 'Copied' : 'Copy SSH launch command'}
      </Typography>
    </MenuItem>
  );
};
